// English strings of the Keys panel.

export const strings = {
  title: "Keys",
  intro: "Shortcuts work anywhere except in a form field.",
} as const;
